import dndItemTypes from '../../constants/dndItemTypes'
import SortableWrapperContainer from '../../containers/dnd/SortableWrapperContainer'
import ItemContainer from '../../containers/PageEditSelection/ItemContainer'
import Translation from '../Translation/cont/Translation'
import TranslationDate from '../Translation/cont/TranslationDate'
import ItemsPerCinema from './ItemsPerCinema'

const Collection = ({
    id, 
    isEdited, 
    dateStart, 
    dateEnd, 
    items, 
    movieMappings, 
    movieExtensions, 
    setEditedFalse, 
    basicUrlEdit,
    removeItemFromCollection, 
    pyMovies, 
    compesoMovies,
    vistaMovies,
    marsxMovies,
    dieselMovies,
    cortecMovies,
    khMovies, 
    filterValue, 
    filterType, 
    reorderCollectionItems, 
    week, 
    cliMovies, 
    highlightsItems,
    adsItems,
    advertisementsItems,
    weischerAdsItems,
    attributes,
    cliCinemas,
    sortedCinemasIds
}) => {
    
    const renderEditedText = (
        isEdited === true ? (<div className="edited-button-container cursor-pointer" onClick={() => setEditedFalse()}>
            <button className="text-periode-edited-wrapper">
                <div className="edited-button text-periode-edited">
                    <p className="screen-reader-text">
                        schreibgeschützt
                    </p>
                </div>
            </button>
            <span className="text-small-regular manually-edited">  
                <Translation id="manually_sorted">manuell geordnet</Translation>
            </span>
        </div>) : null
    )

    const itemList = items.map((item, index) => (
        <li key={index} className={"item-drag"}>
            <SortableWrapperContainer 
                index={index} 
                moveItem={reorderCollectionItems}
                listId={'list-' + id}
                dndType={dndItemTypes.PROGRAM_ITEM_SORT}
            >
                <ItemContainer
                    id={item.id}
                    type={item.type}
                    removeItemFromCollection={removeItemFromCollection}
                    pathnameEdit={basicUrlEdit ? `${basicUrlEdit}/${item.type}/${item.id}` : false}
                />
            </SortableWrapperContainer>
        </li>
    ))

    return (
        <li className="periode-item-container">
            <div className='text-periode-date accordion-headline title-large-light'>
            <TranslationDate hasYear={true} string={dateStart}/>  - <TranslationDate hasYear={true} string={dateEnd}/> 
            </div>

            <div className='text-periode-week title-large-light'>
                <Translation id="movie_sort_cw">KW</Translation> {week}
            </div>

            {renderEditedText}
            
            <div className="item-drag-container">
                <ul className={'grid-container'}>
                    {itemList}
                </ul>
                {sortedCinemasIds.length > 1 && <div className="items-per-cinema-list-wrapper">
                    <ItemsPerCinema
                        sortedCinemasIds={sortedCinemasIds}
                        cliCinemas={cliCinemas}
                        dieselMovies={dieselMovies}
                        cortecMovies={cortecMovies}
                        pyMovies={pyMovies}
                        filterType={filterType}
                        filterValue={filterValue}
                        cliMovies={cliMovies}
                        movieExtensions={movieExtensions}
                        movieMappings={movieMappings}
                        collectionItems={items}
                        highlightsItems={highlightsItems}
                        adsItems={adsItems}
                        advertisementsItems={advertisementsItems}
                        weischerAdsItems={weischerAdsItems}
                        items={items}
                        khMovies={khMovies}
                        vistaMovies={vistaMovies}
                        marsxMovies={marsxMovies}
                        compesoMovies={compesoMovies}
                        attributes={attributes}
                    />
                </div>}
            </div>
        </li>
    )
}

export default Collection
